import { Box, SxProps, Theme, Typography } from '@mui/material';

const MAX_IMAGE_WIDTH = 300;

export type ImageCardProps = Readonly<{
  imageUrl: string;
  title: string;
  description: string;
  onClick: () => void;
}>;

export const ImageCard = ({ title, description, imageUrl, onClick }: ImageCardProps) => {
  return (
    <Box sx={containerSx} onClick={onClick}>
      <Box component="img" src={imageUrl} sx={imageSx} />
      <Box sx={titleDescContainerSx}>
        <Typography
          variant="text-lg-semibold"
          color={({ backrs }) => backrs.colors['Colors/Text/text-primary']}
        >
          {title}
        </Typography>
        <Box>
          <Typography
            variant="text-sm-regular"
            color={({ backrs }) => backrs.colors['Colors/Text/text-tertiary']}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: backrs.radius['radius-xl'],
  overflow: 'hidden',
  border: '1px solid black',
  width: 'fit-content',
  maxWidth: { xs: '100%', sm: MAX_IMAGE_WIDTH },
  cursor: 'pointer',
  transition: 'all 0.3s ease-in-out',
  userSelect: 'none',
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  '&:hover': {
    boxShadow: backrs.shadows['shadow-xl'],
    transform: 'translate(-2px, -2px)',
  },
  '&:active': {
    outline: 'none',
    transform: 'translate(0px, 0px)',
    boxShadow: 'none',
    transition: 'all 0s',
  },
});

const imageSx: SxProps<Theme> = {
  height: 'auto',
  width: '100%',
};

const titleDescContainerSx: SxProps<Theme> = ({ backrs }) => ({
  gap: backrs.spacing['spacing-xxs'],
  px: backrs.spacing['spacing-xl'],
  py: backrs.spacing['spacing-2xl'],
});
